import React, { useState } from "react";
import {
  Modal,
  Box,
  TextField,
  Button,
  Typography,
  Snackbar,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

import InvoiceModal from "./InvoiceModal";
import {
  checkInvoiceNumberExists,
  getLatestCPPaymentStatus,
  updateCPaymentStatus,
} from "../../Services/LeadService";
import axios from "axios";

function InvoiceDetailsModal({
  open,
  onClose,
  leadData,
  setIsInvoiceGenerated,
  handleFileUpload,
  handleUploadButtonClick,
  fileInputRef,
  leadstatus,
  setLeadStatus,
  data,
}) {
  const [invoiceDate, setInvoiceDate] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");

  
  const todayStr = new Date().toISOString().split("T")[0];


  // const handleSubmit = async () => {
  //   const hasSpaces = /\s/;

  //   if (!invoiceDate || !invoiceNumber) {
  //     setToastMessage("Please fill out all fields.");
  //     setShowToast(true);
  //     return;
  //   }

  //   if (hasSpaces.test(invoiceNumber)) {
  //     setToastMessage("Invoice number cannot contain spaces.");
  //     setShowToast(true);
  //     return;
  //   }

  //   if (invoiceNumber.length > 16) {
  //     setToastMessage("Invoice number cannot exceed 16 characters.");
  //     setShowToast(true);
  //     return;
  //   }

  //   const agreementDate = leadData?.AgreementDate;
  //   const today = new Date();
  //   today.setHours(0, 0, 0, 0); // Normalize today’s date to midnight

  //   const selectedInvoiceDate = new Date(invoiceDate);
  //   if (agreementDate && selectedInvoiceDate < new Date(agreementDate)) {
  //     setToastMessage("Invoice date cannot be before agreement date.");
  //     setShowToast(true);
  //     return;
  //   }

  //   const currentDay = today.getDate(); // Get current day of the month (1-31)

  //   // Get the previous month's date (Do not alter today, create a new date object)
  //   const previousMonth = new Date(today); // Create a new object for previousMonth
  //   previousMonth.setMonth(today.getMonth() - 1);
  //   previousMonth.setHours(0, 0, 0, 0); // Set time to midnight for accurate comparison

  //   // Check if the invoice date is from the previous month
  //   const isPreviousMonth =
  //     selectedInvoiceDate.getMonth() === previousMonth.getMonth() &&
  //     selectedInvoiceDate.getFullYear() === previousMonth.getFullYear();

  //   // If the invoice date is from the previous month and current date is greater than the 2nd
  //   if (isPreviousMonth && currentDay > 2) {
  //     setDialogMessage(
  //       "You cannot submit last month's invoice in the current month." +
  //         "This is because the GST for the previous month has already been processed." +
  //         "Please update your invoice date to the current month and re-upload your invoice."
  //     );
  //     setOpenDialog(true);
  //     return;
  //   }

  //   try {
  //     const result = await checkInvoiceNumberExists(
  //       leadData?.CpId,
  //       invoiceNumber
  //     );
  //     console.log("Invoice check result:", result);

  //     const ledgerId = leadData?.CP_FV_LedgerID;
  //     const body = {
  //       invoiceNumber: invoiceNumber,
  //       ledgerId: String(ledgerId),
  //     };

  //     if (!body.invoiceNumber || !body.ledgerId) {
  //       console.error(
  //         "Missing invoiceNumber or ledgerId in request body:",
  //         body
  //       );
  //       setToastMessage("Invoice number or ledger ID is missing.");
  //       setShowToast(true);
  //       return;
  //     }

  //     if (result.exists === true || result.exists === "true") {
  //       setToastMessage("Invoice number already exists in supabase.");
  //       setShowToast(true);
  //       return;
  //     }

  //     // Check from backend (Farvision)
  //     try {
  //       const response = await axios.post(
  //         process.env.REACT_APP_SEND_OTP_MESSAGE_A2P_SERVICE +
  //           "cpInvoices/checkInvoiceNumber",
  //         body,
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );

  //       console.log("Backend response:", response);
  //       if (response?.data?.isExist) {
  //         console.log(
  //           "Invoice number already exists in backend:",
  //           response.data
  //         );
  //         setToastMessage("Invoice number already exists.");
  //         setShowToast(true);
  //         return;
  //       } else {
  //         console.log(
  //           "Invoice number does not exist in backend, proceeding to open modal..."
  //         );
  //         setInvoiceModalOpen(true); // Open modal if all checks pass
  //       }
  //     } catch (error) {
  //       console.error("Backend error:", error.message);
  //       setToastMessage("Error checking invoice from backend.");
  //       setShowToast(true);
  //     }
  //   } catch (error) {
  //     console.error("Invoice check error:", error);
  //     setToastMessage("Error checking invoice number. Please try again.");
  //     setShowToast(true);
  //   }
  // };


  const handleSubmit = async () => {
  const hasSpaces = /\s/;

  if (!invoiceDate || !invoiceNumber) {
    setToastMessage("Please fill out all fields.");
    setShowToast(true);
    return;
  }

  if (hasSpaces.test(invoiceNumber)) {
    setToastMessage("Invoice number cannot contain spaces.");
    setShowToast(true);
    return;
  }

  if (invoiceNumber.length > 16) {
    setToastMessage("Invoice number cannot exceed 16 characters.");
    setShowToast(true);
    return;
  }

  const agreementDate = leadData?.AgreementDate;
  const today = new Date();
  // const today = new Date("2025-10-02");

  today.setHours(0, 0, 0, 0);

  const selectedInvoiceDate = new Date(invoiceDate);
  selectedInvoiceDate.setHours(0, 0, 0, 0);

  // 🚫 Block manually typed future dates
  if (selectedInvoiceDate > today) {
    setToastMessage("Invoice date cannot exceed today’s date.");
    setShowToast(true);
    return;
  }
  
  if (agreementDate && selectedInvoiceDate < new Date(agreementDate)) {
    setToastMessage("Invoice date cannot be before agreement date.");
    setShowToast(true);
    return;
  }

  const currentDay = today.getDate();
  const currentMonth = today.getMonth(); // 0–11
  const currentYear = today.getFullYear();

  // Previous month (handle January -> December case)
  const prevMonth = currentMonth === 0 ? 11 : currentMonth - 1;
  const prevMonthYear = currentMonth === 0 ? currentYear - 1 : currentYear;

  const selectedMonth = selectedInvoiceDate.getMonth();
  const selectedYear = selectedInvoiceDate.getFullYear();

  // ✅ RULES:
  // 1. Block all invoices older than previous month (e.g., Aug/July if today is Oct)
  const isOlderThanPrevMonth =
    selectedYear < prevMonthYear ||
    (selectedYear === prevMonthYear && selectedMonth < prevMonth);

  if (isOlderThanPrevMonth) {
    setDialogMessage(
       "You cannot submit last month's invoice in the current month. " +
      "This is because the GST for the previous month has already been processed."+
      "Please update your invoice date to the current month and re-upload your invoice."
    );
    setOpenDialog(true);
    return;
  }

  // 2. If today's date > 2 → block previous month invoices (allow only current month)
  const isPrevMonthInvoice =
    selectedMonth === prevMonth && selectedYear === prevMonthYear;

  if (currentDay > 2 && isPrevMonthInvoice) {
    setDialogMessage(
      "You cannot submit last month's invoice in the current month. " +
      "This is because the GST for the previous month has already been processed."+
      "Please update your invoice date to the current month and re-upload your invoice."
      
    );
    setOpenDialog(true);
    return;
  }

  // ✅ If all checks pass — continue to invoice number checks
  try {
    const result = await checkInvoiceNumberExists(leadData?.CpId, invoiceNumber);
    console.log("Invoice check result:", result);

    const ledgerId = leadData?.CP_FV_LedgerID;
    const body = { invoiceNumber, ledgerId: String(ledgerId) };

    if (!body.invoiceNumber || !body.ledgerId) {
      setToastMessage("Invoice number or ledger ID is missing.");
      setShowToast(true);
      return;
    }

    if (result.exists === true || result.exists === "true") {
      setToastMessage("Invoice number already exists in Supabase.");
      setShowToast(true);
      return;
    }

    const response = await axios.post(
      `${process.env.REACT_APP_SEND_OTP_MESSAGE_A2P_SERVICE}cpInvoices/checkInvoiceNumber`,
      body,
      { headers: { "Content-Type": "application/json" } }
    );

    if (response?.data?.isExist) {
      setToastMessage("Invoice number already exists in backend.");
      setShowToast(true);
      return;
    }

    setInvoiceModalOpen(true);
  } catch (error) {
    console.error("Invoice check error:", error);
    setToastMessage("Error checking invoice number. Please try again.");
    setShowToast(true);
  }
};

  const handleInvoiceGenerationComplete = () => {
    setIsInvoiceGenerated(true); // Mark invoice as generated
    setInvoiceModalOpen(false);
    setInvoiceDate("");
    setInvoiceNumber("");
    onClose();
  };

  if (!open) return null;

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <Typography
          variant="h6"
          sx={{ mb: 3, fontWeight: 600, fontSize: "1.6rem" }}
        >
          Invoice Details
        </Typography>

        {/* Form fields displayed vertically */}
        <Box sx={{ pt: 1, px: 1 }}>
          {/* Invoice Date Label */}
          <Typography sx={{ fontSize: "1.4rem", fontWeight: 500, mb: 1 }}>
            Invoice Date <span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            type="date"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={invoiceDate}
            onChange={(e) => setInvoiceDate(e.target.value)}
            sx={{ mb: 3 }}
            inputProps={{
              max: todayStr,
              style: { fontSize: "1.4rem" },
            }}
          />

          {/* Invoice Number Label */}
          <Typography sx={{ fontSize: "1.4rem", fontWeight: 500, mb: 1 }}>
            Invoice Number <span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            fullWidth
            value={invoiceNumber}
            onChange={(e) => setInvoiceNumber(e.target.value)}
            sx={{ mb: 3 }}
            inputProps={{ maxLength: 16, style: { fontSize: "1.4rem" } }}
          />
        </Box>

        <Box sx={{ display: "flex", justifyContent: "end", mt: 3, gap: 2 }}>
          <Button
            onClick={onClose}
            variant="outlined"
            color="primary"
            sx={{
              px: 3,
              py: 1.2,
              fontSize: "1.4rem",
              borderColor: "primary.main",
              color: "primary.main",
              "&:hover": {
                backgroundColor: "rgba(25, 118, 210, 0.08)",
                borderColor: "primary.main",
              },
            }}
          >
            Cancel
          </Button>

          <Button
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            sx={{ px: 3, py: 1.2, fontSize: "1.4rem" }}
          >
            Submit
          </Button>
        </Box>

        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          sx={{
            maxWidth: "400px",
            margin: "auto",
            borderRadius: "10px",
          }}
        >
          <DialogContent
            sx={{
              padding: "16px 24px",
              fontSize: "1.6rem",
              color: "#333",
              lineHeight: "1.8",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "stretch",
            }}
          >
            <Box
              sx={{
                backgroundColor: "#e3f2fd",
                padding: "10px",
                borderTopLeftRadius: "10px",
                borderTopRightRadius: "10px",
                borderBottomLeftRadius: "10px",
                borderBottomRightRadius: "10px",
                width: "100%",
                textAlign: "center",
                marginBottom: "16px",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontSize: "1.8rem",
                  fontWeight: "bold",
                  color: "#1976d2",
                }}
              >
                Important Note !!
              </Typography>
            </Box>

            {/* Dialog Message */}
            <Typography
              variant="body1"
              sx={{
                fontSize: "1.6rem",
                color: "#555",
                marginBottom: "16px",
                lineHeight: "1.6",
                textAlign: "justify",
              }}
            >
              {dialogMessage}
            </Typography>
          </DialogContent>

          <DialogActions
            sx={{
              padding: "8px 16px",
              justifyContent: "flex-end",
              backgroundColor: "#f7f7f7",
              borderBottomLeftRadius: "10px",
              borderBottomRightRadius: "10px",
            }}
          >
            <Button
              onClick={handleCloseDialog}
              color="primary"
              sx={{
                fontSize: "1.3rem",
                fontWeight: 600,
                padding: "8px 16px",
                backgroundColor: "#1976d2",
                color: "#fff",
                borderRadius: "5px",
                "&:hover": {
                  backgroundColor: "#1565c0",
                },
              }}
            >
              Close
            </Button>
          </DialogActions>

         
          <style>
            {`
      .MuiDialog-paper {
        border-radius: 10px; /* Rounded corners for the entire dialog */
        border: 1px solid #1976d2; /* Blue border around the dialog */
      }
    `}
          </style>
        </Dialog>


        <InvoiceModal
          open={invoiceModalOpen}
          onClose={() => setInvoiceModalOpen(false)}
          leadData={leadData}
          invoiceDate={invoiceDate}
          invoiceNumber={invoiceNumber}
          onInvoiceProcessComplete={handleInvoiceGenerationComplete}
          onUploadComplete={async () => {
            setToastMessage("Invoice uploaded successfully!");

            setShowToast(true);

            try {
              const resp = await getLatestCPPaymentStatus(data?.id);
              console.log("toast", resp);
              setLeadStatus(resp); // ✅ Will update parent and re-render both
            } catch (err) {
              console.error("❌ Failed to fetch updated status:", err);
            }
          }}
          handleFileUpload={handleFileUpload}
          handleUploadButtonClick={handleUploadButtonClick}
          fileInputRef={fileInputRef}
        />
      </div>

      <Snackbar
        open={showToast}
        autoHideDuration={4000}
        onClose={() => setShowToast(false)}
        message={toastMessage}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        ContentProps={{
          sx: {
            backgroundImage: "linear-gradient(135deg, #1976d2, #42a5f5)",
            color: "#fff",
            fontSize: "1.4rem",
            fontWeight: 500,
            padding: "1rem 1.6rem",
            borderRadius: "8px",
            boxShadow: "0px 4px 20px rgba(0,0,0,0.2)",
          },
        }}
      />
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    width: "100vw",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1300,
  },
  modal: {
    backgroundColor: "#fff",
    padding: "2rem",
    borderRadius: "10px",
    width: "100%",
    maxWidth: "480px",
    boxShadow: "0px 10px 30px rgba(0,0,0,0.2)",
  },
};

export default InvoiceDetailsModal;
